<template>
  <v-card @click="showUser(user), scrollToTop()" height="220px" flat :width="widthCard">
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm12 text-xs-center>
        <img
          :src="user.image"
          :style="styleImage()"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap >
      <v-card-text  class="pa-0" style="height: 100px">
        <v-flex xs12 sm12 class="pt-1 text-xs-center text-12-security font-weight-bold grey-security">
          {{ user.full_name }}
        </v-flex>
        <v-flex xs12 sm12 class="grey-security text-11-security text-xs-center">
          {{ user.position }}
        </v-flex>
        <v-flex xs12 sm12 class="grey-security text-12-security font-weight-bold text-xs-center">
          {{ user.company }}
        </v-flex>
      </v-card-text>
    </v-layout>
  </v-card>
</template>

<script>
import { mapActions } from "vuex"

export default {
  props: {
    user: { type: Object, required: true },
    widthCard: { type: String, required: false}
  },
  methods: {
    ...mapActions("user", ["fetchUser", "hideCompanyChart"]),
    styleImage() {
      return `height: 90px; width: 90px; object-fit: cover; border-radius: 50%; border: 3px solid ${this.user.color}`
    },
    showUser(user) {
      this.hideCompanyChart()
      this.fetchUser(user.id)
      this.$router.push({
        name: "user-show",
        params: { id: user.id }
      });
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}
</script>